export default {
    APPLY: "apply",
    CREDIT_LIMIT_CHANGE: "credit_limit_change"
}
